/**
 *
 * EventMessage
 *
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { slideUp } from 'styles/animation';



const EventMessageWrapper = styled.div`
  display: flex;
  margin: 0 1rem;
  justify-content: center; 
  flex-direction: row;
  align-items: center; 
  opacity: 0;
  transform: translateY(10px);
  will-change: transform;
  animation: ${slideUp} 0.4s ease-in-out 0.08s forwards;
`;

const EventMessageText = styled.div`
  color: ${p => p.theme.palette.grey3};
  font-style: italic;
  font-size: 9px;
  text-align: center;
  font-weight: 400;
  margin: 10px 0;
  line-height: 11px;
  padding: 5px 20px;
  color: #3D4E6380;
  background: ${p => p.bgColor + '33'};
  border-radius: 15px;
  flex: none;
  max-width: 210px;
`;

const EventLine = styled.div`
  top: 50%;
  width: 100%;
  border-top: 1px dashed ${p => p.bgColor + '80'};
  flex: 1;
`;

const CancelEvent = styled.button`
  border: none;
  background: transparent;
  font-size: 9px;
  line-height: 11px;
  text-align: center;
  color: ${p => p.bgColor};
  opacity: 0.8;
  margin: 0;
  margin-left: 10px;
  padding: 0;
  cursor: ${p => p.disabled ? 'no-drop': 'pointer'};
  outline: none;
`;

const Translate = (text, category, keyValues, Language) => {
    if(!Language || !category) return text;

    let resultantText = Language.backend[category];
    if(keyValues && Array.isArray(keyValues)){
        for(let i=0; i<keyValues.length; i++) resultantText = resultantText.replace(/\{[a-zA-Z]*?\}/,keyValues[i]);
    }
    return resultantText;
}

export const EventMessage = ({message, Language, userSettingColor, isCancelable, onCancelEvent, ...props}) => {

  let [isCancelled, setIsCancelled] = useState(false);
  let translatedMessage = message && Translate(message.event, message.category, message.keyValues, Language);

  let onCancelClicked = () => {
    !isCancelled && onCancelEvent();
    setIsCancelled(true)
  }
  return (
    <EventMessageWrapper id="insent-event-message-event-message-wrapper">
      <EventLine id="insent-event-message-event-line" bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null} />
      <EventMessageText id="insent-event-message-event-message-text" bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}>
        {translatedMessage}
        {isCancelable && <CancelEvent disabled={isCancelled} onClick={onCancelClicked} bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null}>{isCancelled? Language.Cancelling : Language.Cancel}</CancelEvent>}
      </EventMessageText>
      <EventLine id="insent-event-message-event-line" bgColor={userSettingColor ? userSettingColor.headerBackgroundColor : null} />
    </EventMessageWrapper>
  );
}

EventMessage.propTypes = {
  message: PropTypes.shape({
    event: PropTypes.string
  }),
  userSettingColor: PropTypes.shape({
    headerBackgroundColor: PropTypes.string,
    headerTextColor: PropTypes.string,
  }),
};

export default EventMessage;
